import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function timeSpent10Min() {
    const category = GA_EVENTS.timeSpent.category;
    const action = GA_EVENTS.timeSpent.actions.time_spent_10mins;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function homePagePromo(sequence, text) {
    const category = GA_EVENTS.homePagePromo.category;
    const action = `${GA_EVENTS.homePagePromo.actions.homePage}${sequence}`;
    const label = text;

    setBehaviourEvent({ category, action, label });
}

export {
    timeSpent10Min,
    homePagePromo,
};
